import script from "./orderList.vue?vue&type=script&setup=true&lang=ts"
export * from "./orderList.vue?vue&type=script&setup=true&lang=ts"

import "./orderList.vue?vue&type=style&index=0&id=d31f119a&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d31f119a"]])

export default __exports__